import { render, staticRenderFns } from "./SecStudy_SKMA.vue?vue&type=template&id=4e73de48&scoped=true&"
import script from "./SecStudy_SKMA.vue?vue&type=script&lang=js&"
export * from "./SecStudy_SKMA.vue?vue&type=script&lang=js&"
import style0 from "./SecStudy_SKMA.vue?vue&type=style&index=0&id=4e73de48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e73de48",
  null
  
)

export default component.exports